import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import {
  APP_ID,
  // COMPANY_ID,
  API_URL, CHECKOUT_API_URL
} from "./constants"
import { isAuthenticated } from "../utils/utils"
import { getDeviceId, inBrowser } from "@omnichannel/ace-b2b-elements"
import { getCompanyId } from '../utils/utils'

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

const appMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => {
    let bearerAccessToken = "x"
    const accessToken =
      (inBrowser && localStorage.getItem("access-token")) || ""
    if (accessToken.length) {
      bearerAccessToken = `Bearer ${accessToken}`
    }

    const branch = JSON.parse(
      (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
    )
    let branchId = branch._id

    headers = {
      ...headers,
      appid: APP_ID,
      companyId: getCompanyId(),
      deviceId,
      ...(branchId ? { branchId } : {}),
      Authorization: bearerAccessToken,
    }

    let token = ""
    if (isAuthenticated()) {
      if (token) {
        headers.token = token
      }
    }
    return { headers }
  })
  return forward(operation)
})

const httpLink = new HttpLink({
  uri: CHECKOUT_API_URL ? CHECKOUT_API_URL : `${API_URL}/checkout/graphql`,
  fetch,
})

const checkoutClient = new ApolloClient({
  cache: inBrowser
    ? new InMemoryCache().restore(window.__APOLLO_STATE__)
    : new InMemoryCache(),
  link: from([appMiddleware, httpLink]),
})

export default checkoutClient
